import { v4 as uuid } from "uuid";

const STORAGE_KEY = "dr-device-id";

// Stable, anonymous identifier persisted per browser/device (localStorage survives reloads
// and new tabs, unlike sessionStorage). Lets us correlate multiple Sentry events/sessions
// back to the same device without relying on IP address or user-agent matching.
export function getDeviceId(): string {
  let id = localStorage.getItem(STORAGE_KEY);
  if (!id) {
    // Pas crypto.randomUUID() : absent hors contexte sécurisé (test tablette
    // en http://IP:5173), alors que l'app doit booter partout.
    id = uuid();
    localStorage.setItem(STORAGE_KEY, id);
  }
  return id;
}
